import  React from "react";
import { SimpleCard } from "../../../ui/Layout/SimpleCard";
import { H3 } from "../../../ui/Heading";

export default () => (
  <SimpleCard>
    <H3 textAlign="center">not allowed to do that</H3>
  </SimpleCard>
);
